<!-- 安家服务 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent">
        <div class="ele-table-tool-default">
          <el-button size="small" type="primary" icon="el-icon-plus" :disabled="table.tableData.length > 2" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addRelocation">新建</el-button>
        </div>
        <el-table
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="imageUrl" label="图片" align="center">
            <template slot-scope="scope">
              <div class="demo-image__preview" v-if="scope.row.imageUrl!=''&&scope.row.imageUrl!=null">
                <el-image  v-for="item in scope.row.imageUrl.split('|')" :preview-src-list="scope.row.srcList" :key="item" style="width: 100px; height: 50px;margin-right: 10px" :src="bindSrc(item)"></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="内容" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.content"></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor}">编辑</el-button>
              <el-popconfirm class="real_pop" title="您确定要删除该Banner信息吗？" @confirm="handleOperation('remove', scope.row)">
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'RelocationServiceManagement',
    data () {
      return {
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
          total: 0, // 表格总数
        },
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        this.$api.findSettleDown({ page:1,size:this.$store.state.size}).then(res => {
          if (res.data.status == 200) {
            this.table.total = Number(res.data.data.total);
            this.table.tableData = res.data.data.records;
            for (let i = 0; i < this.table.tableData.length; i++){
              if(this.table.tableData[i].imageUrl !='' && this.table.tableData[i].imageUrl != null && this.table.tableData[i].imageUrl !=undefined){
                let array = this.table.tableData[i].imageUrl.split("|");
                for (let j = 0; j < array.length; j++){
                  array[j] = this.bindSrc(array[j]);
                }
                this.table.tableData[i].srcList = array;
              }
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 拼接页面图片地址
      bindSrc(url){
        return api_url+"/"+url;
      },
      // 新建Relocation
      addRelocation(){
        this.$router.push({
          path:'/RelocationServiceManagementOperation',
          query:{ data:this.table.tableData.length }
        });
      },

      // 编辑/删除
      handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.$router.push({
            path:'/RelocationServiceManagementOperation',
            query:{ data:row }
          });
        }
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 25);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 122);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 25;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 25);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 122);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 25;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/RelocationServiceManagement.vue